import { AmlVerificationStatus } from '@lucky7ventures/lucky-components';

import { RootState } from '@/models/root-state.model';

export const selectAmlVerificationStatus = (state: RootState): AmlVerificationStatus | null =>
  state.aml.verificationStatus;
export const selectAmlVerificationStatusError = (state: RootState): boolean =>
  state.aml.verificationStatusError;
